export default "__VITE_ASSET__Dh$NIbXF__"